import * as yup from 'yup'
import { selectionRequired } from '../../../../validators'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

export const warningPage = propOverrides => {
  const props = {
    pageId: 'needed_page',
    fieldType: 'text',
    fieldName: 'needed',
    label: 'needed',
    className: css.hidden,
    validation: null,
    value: 'Yes',
    warning: 'needed',
    actionType: 'next',
    buttonText: 'Acknowledge and continue',
    buttonStyle: 'secondary',
    ...propOverrides
  }

  // By default, the user must acknowledge
  if (props.validation === null) {
    props.validation = yup.object().shape({
      [props.fieldName]: selectionRequired()
    })
  }

  return {
    id: props.pageId,
    validation: props.validation,
    fields: [
      {
        type: 'content',
        content: props.warning
      },
      {
        type: props.fieldType,
        name: props.fieldName,
        className: css.hidden,
        label: props.label,
        value: props.value
      }
    ],
    action: {
      type: props.actionType,
      buttonText: props.buttonText,
      buttonProps: {
        variation: props.buttonStyle
      }
    }
  }
}
